import { datadogRum } from '@datadog/browser-rum';

import useSystemPlans from '@/hooks/useSystemPlans';

import { isApiError } from '@/utils/request';

import GenericError from '@/components/Error/GenericError';

import { Plan } from '@/_generated/api-clients/xp';
import PreviewTemplateModal from '@/routes/TrainingPlans/CopyTemplateModal/PreviewTemplateModal';
import TemplateModal from '@/routes/TrainingPlans/CopyTemplateModal/TemplateModal';
import { useAddReadOnlyPlan } from '@/routes/TrainingPlans/hooks/useAddReadOnlyPlan/useAddReadOnlyPlan';

interface ChooseTemplateProps {
  handlePreviewPlan: (template: Plan) => void;
  handleTemplateBackButton: () => void;
  onShowCopyPlan: (id: string) => void;
  previewTemplate: Plan | null;
  setShowPreview: (show: boolean) => void;
  setShowTemplateModal: (show: boolean) => void;
  showPreview: boolean;
  showTemplateModal: boolean;
}

// @TODO Lot of prop drilling throughout.  Would be nice to move to context or similar.
const ChooseTemplate: React.FC<ChooseTemplateProps> = ({
  handlePreviewPlan,
  handleTemplateBackButton,
  onShowCopyPlan,
  previewTemplate,
  setShowPreview,
  setShowTemplateModal,
  showPreview,
  showTemplateModal,
}) => {
  const { subscribeReadonlyPlan, isPending, pendingPlanId, complianceModal } =
    useAddReadOnlyPlan();

  const { systemPlans: templates, systemPlansError: templatesError } =
    useSystemPlans();

  const handleAddFromPreview = (template: Plan) => {
    const isCompliance =
      template.category === 'compliance' && template.readonly;
    if (isCompliance) {
      setShowPreview(false);
    }
    subscribeReadonlyPlan(template);
  };

  if (isApiError(templatesError)) {
    datadogRum.addError(
      templatesError instanceof Error
        ? templatesError
        : new Error(String(templatesError)),
    );
    return <GenericError />;
  }

  return (
    <>
      {!!templates.length && (
        <>
          <TemplateModal
            isOpen={showTemplateModal}
            onClose={() => setShowTemplateModal(false)}
            onCopy={onShowCopyPlan}
            onPreviewTemplateClick={handlePreviewPlan}
            templates={templates}
            onAdd={subscribeReadonlyPlan}
            subscribingTemplateId={pendingPlanId}
            isPending={isPending}
          />
          {previewTemplate && (
            <PreviewTemplateModal
              isOpen={showPreview}
              onClose={() => setShowPreview(false)}
              onCopy={onShowCopyPlan}
              onTemplateBackButtonClick={handleTemplateBackButton}
              plan={previewTemplate}
              onAdd={handleAddFromPreview}
              isLoading={isPending && pendingPlanId === previewTemplate.id}
            />
          )}
        </>
      )}
      {complianceModal}
    </>
  );
};

export default ChooseTemplate;
